import { MantineColorsTuple } from '@mantine/core'

export default {
  black: '#161616',
  white: '#FAFAFA',
  primary: [
    '#DBFBFF', // 0 - primary-100
    '#B9F6FE', // 1 - primary-200
    '#20D8F0', // 2 - primary-400
    '#00BAD2', // 3 - primary-500
    '#0098AC', // 4 - primary-550
    '#007B8B', // 5 - primary-600
    '#005A66', // 6 - primary-700
    '#003E45', // 7 - primary-800
    '#003036', // 8 - primary-900
    '#003036'
  ] as MantineColorsTuple,
  secondary: [
    '#D4F2FF', // 0 - secondary-100
    '#B5E9FF', // 1 - secondary-200
    '#00A3E9', // 2 - secondary-400
    '#008ECB', // 3 - secondary-500
    '#0280B7', // 4 - secondary-550
    '#0076AA', // 5 - secondary-600
    '#00638E', // 6 - secondary-700
    '#00425E', // 7 - secondary-800
    '#002535', // 8 - secondary-900
    '#002535'
  ] as MantineColorsTuple,
  gray: [
    '#FAFAFA', // 0 - neutral-50
    '#E5E5E5', // 1 - neutral-200
    '#C7C7C8', // 2 - neutral-300
    '#9B9B9C', // 3 - neutral-400
    '#7D7D7E', // 4 - neutral-500
    '#5F5F60', // 5 - neutral-550
    '#4C4C4E', // 6 - neutral-600
    '#393939', // 7 - neutral-650
    '#262627', // 8 - neutral-700
    '#161616' // 9 - neutral-900
  ] as MantineColorsTuple,
  red: [
    '#FFD3D3', // 0 - error-100
    '#FFA5A5', // 1 - error-200
    '#F15A5A', // 2 - error-400
    '#EB3636', // 3 - error-500
    '#CE3636', // 4 - error-600
    '#B22020', // 5 - error-700
    '#8F0505', // 6 - error-800
    '#8F0505',
    '#8F0505',
    '#8F0505'
  ] as MantineColorsTuple,
  green: [
    '#CDFAEA', // 0 - success-100
    '#A2F2D5', // 1 - success-200
    '#09A56D', // 2 - success-400
    '#00905C', // 3 - success-500
    '#058557', // 4 - success-600
    '#036944', // 5 - success-700
    '#004E32', // 6 - success-800
    '#004E32',
    '#004E32',
    '#004E32'
  ] as MantineColorsTuple,
  orange: [
    '#FFDCC2', // 0 - warning-100
    '#FEBC8C', // 1 - warning-200
    '#DD7528', // 2 - warning-400
    '#D95F07', // 3 - warning-500
    '#BC560B', // 4 - warning-600
    '#993700', // 5 - warning-700
    '#6E2800', // 6 - warning-800
    '#6E2800',
    '#6E2800',
    '#6E2800'
  ] as MantineColorsTuple,
  yellow: [
    '#fef9c3', // 0 - yellow-100
    '#fef08a', // 1 - yellow-200
    '#FDEA9D', // 2 - yellow-400
    '#FCDE68', // 3 - yellow-500
    '#FACC15', // 4 - yellow-600
    '#FACB0E', // 5 - yellow-700
    '#EAB308', // 6 - yellow-800
    '#ca8a04',
    '#C59E00',
    '#854d0e'
  ] as MantineColorsTuple
}
